'use client'

import { useEffect } from 'react'

import { useOrderFlow } from '@/app/[locale]/order/_context/order-flow-context'

import { AStepPatientInfo } from '../../steps/patient-info/a-step-patient-info'

import { OrderFlowShell } from './order-flow-layout'

/**
 * Deep-link flow: cart is pre-filled from the URL; only patient details are shown.
 *
 * Strips query params with `replaceState` so the address bar shows a clean path and the browser
 * back button returns to the true referrer instead of the preset URL.
 */
export function DirectOrderFlow() {
	const { cartProducts } = useOrderFlow()

	useEffect(() => {
		window.history.replaceState(window.history.state, '', window.location.pathname)
	}, [])

	if (!cartProducts.length) return null

	return (
		<OrderFlowShell hasProducts={cartProducts.length > 0}>
			<AStepPatientInfo />
		</OrderFlowShell>
	)
}
